var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContrast({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 35,
    viewBox: "0 0 34 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_6743_25091)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.125 0.0041156L24.7676 0.00539773L26.9899 0.00319998C27.5942 0.00243694 28.3399 -0.0250938 28.9183 0.0962606C29.6914 0.263611 30.3989 0.653466 30.9535 1.21778C31.5993 1.86353 32.0266 2.69564 32.175 3.59692C32.2736 4.21721 32.2321 5.74019 32.2305 6.41734V11.4206V28.9138C32.2241 30.1222 31.8716 31.0406 31.0094 31.9058C29.8159 33.1032 28.7019 33.0947 27.1587 33.0935L24.807 33.0916L16.1262 33.0904L7.42605 33.0907L5.06298 33.0925C4.50452 33.0925 3.84558 33.1224 3.2945 33.0178C1.67711 32.7104 0.216418 31.2066 0.050165 29.5517C-0.0295891 28.7575 0.00969297 27.8199 0.00954036 27.0074L0.00929539 22.1786L0.00664073 4.69347C0.00551142 3.31658 0.313417 2.23647 1.31347 1.23576C2.54571 0.00268092 3.72523 0.00265042 5.31982 0.00435963L7.60543 0.00671015L16.125 0.0041156Z",
    fill: "#424242"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1289 0.00411559L24.7715 0.00539773L26.9938 0.00319998C27.5982 0.00243694 28.3438 -0.0250938 28.9222 0.0962606C29.6953 0.263611 30.4028 0.653466 30.9574 1.21778C31.6033 1.86353 32.0306 2.69564 32.1789 3.59692C32.2775 4.21721 32.236 5.74019 32.2345 6.41734V11.4206V28.9138C32.2281 30.1222 31.8755 31.0406 31.0133 31.9058C29.8199 33.1032 28.7058 33.0947 27.1626 33.0935L24.8109 33.0916L16.1301 33.0904L16.1292 28.9245L15.8771 28.9144C15.9965 28.9071 16.0511 28.926 16.1265 28.8598C16.1625 28.0094 16.1335 26.9146 16.1335 26.0457V20.6982L16.1338 4.51678C15.9577 4.5209 15.7816 4.52008 15.6055 4.51428C15.7532 4.48889 15.9766 4.49337 16.1329 4.49206C16.096 3.05577 16.1292 1.44969 16.1289 0.00411559Z",
    fill: "#ED3727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1329 4.49219C19.4876 4.5529 22.4052 5.81738 24.7374 8.23992C26.949 10.554 28.157 13.6482 28.0981 16.8487C28.0206 20.192 26.6096 23.3655 24.1794 25.6628C22.0169 27.7474 19.1329 28.9161 16.1292 28.9246L15.8771 28.9145C15.9965 28.9072 16.0511 28.9261 16.1265 28.8599C16.1625 28.0096 16.1335 26.9148 16.1335 26.0458V20.6983L16.1338 4.51691C15.9577 4.52103 15.7816 4.52021 15.6055 4.51441C15.7532 4.48901 15.9766 4.4935 16.1329 4.49219Z",
    fill: "#FDCB09"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8758 28.9138C13.0769 28.9291 10.2367 27.6331 8.1948 25.7579C5.77251 23.5247 4.33184 20.424 4.18714 17.1325C4.06047 13.9051 5.21802 10.759 7.40623 8.38331C9.51542 6.10349 12.4872 4.63722 15.6042 4.51367C15.7803 4.51947 15.9564 4.5203 16.1325 4.51617L16.1322 20.6976V26.0451C16.1322 26.914 16.1612 28.0088 16.1252 28.8592C16.0498 28.9254 15.9952 28.9065 15.8758 28.9138Z",
    fill: "#FCF6E8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_6743_25091",
    x: 0,
    y: 0,
    width: 33.2441,
    height: 34.0957,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6743_25091"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6743_25091",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContrast);
export default __webpack_public_path__ + "static/media/contrast.f804d7cd8c4626f195ae1ba2c8302a0d.svg";
export { ForwardRef as ReactComponent };